/* CG Catering ordering (Round 18)
   Shared by: catering menu page, cart panel, catering product pages.
   Rules: 4-hour lead time, ordering window 5:00 AM - 9:00 PM, $150 delivery minimum,
   pickup has no minimum, up to 365 days ahead. All choices land on the order as
   cart attributes so they print on the order, hit Checkmate/Toast and staff alerts. */
(function () {
  'use strict';
  if (window.CGCatering) return;

  var CFG = window.CGC_CONFIG || {};
  var LEAD_MIN = CFG.leadMinutes || 240;
  var OPEN_MIN = CFG.openMinutes != null ? CFG.openMinutes : 5 * 60;
  var CLOSE_MIN = CFG.closeMinutes != null ? CFG.closeMinutes : 21 * 60;
  var SLOT = CFG.slotMinutes || 15;
  var MAX_DAYS = CFG.maxDays || 365;
  var DELIVERY_MIN = CFG.deliveryMinimum != null ? CFG.deliveryMinimum : 15000; // cents
  var DELIVERY_FEE = CFG.deliveryFee != null ? CFG.deliveryFee : 2500;
  var ZIP_OK = CFG.zipPrefixes || ['900','901','902','903','904','905','906','907','908','910','911','912','913','914','915','916','917','918','926','927','928'];
  var LS_KEY = 'cgc_order_v1';

  /* ---------------- helpers ---------------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function dstr(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parseDate(v) { var p = (v || '').split('-'); if (p.length !== 3) return null; return new Date(+p[0], +p[1] - 1, +p[2]); }
  function fmtTime(mins) { var h = Math.floor(mins / 60), m = mins % 60, ap = h >= 12 ? 'PM' : 'AM', hh = h % 12; if (hh === 0) hh = 12; return hh + ':' + pad(m) + ' ' + ap; }
  function parseTime(s) { var m = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec((s || '').trim()); if (!m) return null; var h = +m[1] % 12; if (m[3].toUpperCase() === 'PM') h += 12; return h * 60 + (+m[2]); }
  function niceDate(v) { var d = parseDate(v); if (!d) return ''; return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function el(sel, root) { return (root || document).querySelector(sel); }
  function els(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------- order state ---------------- */
  var state = { mode: 'delivery', date: '', time: '', headcount: '', zip: '', address: '' };
  try { var saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); if (saved) for (var k in saved) if (k in state) state[k] = saved[k]; } catch (e) {}

  function earliestFor(dateStr) {
    var now = new Date();
    var d = parseDate(dateStr);
    if (!d) return OPEN_MIN;
    var start = OPEN_MIN;
    if (dstr(d) === dstr(now)) {
      var mins = now.getHours() * 60 + now.getMinutes() + LEAD_MIN;
      mins = Math.ceil(mins / SLOT) * SLOT;
      if (mins > start) start = mins;
    } else if (d < now) {
      return 99999;
    }
    return start;
  }
  function slotsFor(dateStr) {
    var out = [];
    var start = earliestFor(dateStr);
    for (var t = start; t <= CLOSE_MIN; t += SLOT) out.push(fmtTime(t));
    return out;
  }
  function zipStatus(zip) {
    zip = (zip || '').replace(/\D/g, '').slice(0, 5);
    if (zip.length < 5) return { cls: '', msg: '' };
    if (ZIP_OK.indexOf(zip.slice(0, 3)) > -1) return { cls: 'ok', msg: 'We deliver to ' + zip + '. $' + (DELIVERY_FEE / 100).toFixed(0) + ' delivery fee, added at checkout.' };
    return { cls: 'warn', msg: zip + ' is outside our usual LA / North OC area. Call (562) 907-7017 and we will tell you straight whether we can reach you.' };
  }
  function validate(subtotalCents) {
    var errs = [];
    if (!state.date) errs.push('Pick a date for your order.');
    if (!state.time) errs.push('Pick a ' + (state.mode === 'delivery' ? 'delivery' : 'pickup') + ' time.');
    if (state.date && state.time) {
      var d = parseDate(state.date), t = parseTime(state.time);
      if (d && t != null) {
        var when = new Date(d.getFullYear(), d.getMonth(), d.getDate(), Math.floor(t / 60), t % 60);
        if (when.getTime() < Date.now() + LEAD_MIN * 60000 - 60000) errs.push('Catering orders need at least ' + (LEAD_MIN / 60) + ' hours notice. Pick a later time.');
        if (t < OPEN_MIN || t > CLOSE_MIN) errs.push('Choose a time between ' + fmtTime(OPEN_MIN) + ' and ' + fmtTime(CLOSE_MIN) + '.');
      }
    }
    if (state.mode === 'delivery') {
      if (!/^\d{5}$/.test(state.zip || '')) errs.push('Enter the delivery zip code.');
      if (subtotalCents != null && subtotalCents < DELIVERY_MIN) errs.push('Delivery orders have a ' + money(DELIVERY_MIN) + ' minimum. Add ' + money(DELIVERY_MIN - subtotalCents) + ' more, or switch to pickup (no minimum).');
    }
    return errs;
  }
  function attributes() {
    var isDel = state.mode === 'delivery';
    return {
      'Catering Order': 'Yes',
      'Order Type': isDel ? 'Catering Delivery' : 'Catering Pickup',
      'Order Timing': 'Scheduled',
      'Scheduled Date': state.date || '',
      'Scheduled Time': state.time || '',
      'Headcount': state.headcount || '',
      'Delivery Zip': isDel ? (state.zip || '') : '',
      'Delivery Address': isDel ? (state.address || '') : ''
    };
  }
  var syncTimer = null;
  function persist(immediate) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) {}
    clearTimeout(syncTimer);
    var run = function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attributes() }) })
        .then(function (r) { return r.json(); }).then(function (c) { cart = c; emit(); }).catch(function () {});
    };
    if (immediate) run(); else syncTimer = setTimeout(run, 400);
  }
  function hydrateFromCart(c) {
    var a = (c && c.attributes) || {};
    if (a['Order Type']) state.mode = /Pickup/i.test(a['Order Type']) ? 'pickup' : 'delivery';
    if (a['Scheduled Date']) state.date = a['Scheduled Date'];
    if (a['Scheduled Time']) state.time = a['Scheduled Time'];
    if (a['Headcount']) state.headcount = a['Headcount'];
    if (a['Delivery Zip']) state.zip = a['Delivery Zip'];
    if (a['Delivery Address']) state.address = a['Delivery Address'];
  }

  /* ---------------- cart ---------------- */
  var cart = null;
  var listeners = [];
  function onCart(fn) { listeners.push(fn); if (cart) fn(cart); }
  function emit() { listeners.forEach(function (fn) { try { fn(cart); } catch (e) {} }); }
  function loadCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      cart = c; hydrateFromCart(c); emit(); return c;
    });
  }
  function addItem(variantId, qty, props) {
    var body = { items: [{ id: variantId, quantity: qty, properties: props || {} }] };
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to order'); return j; }); })
      .then(function () { return persistThenLoad(); });
  }
  function persistThenLoad() {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attributes() }) })
      .then(function () { return loadCart(); });
  }
  function refreshThemeCartBubble() {
    try {
      fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        var wrap = document.getElementById('cart-icon-bubble');
        if (wrap && s['cart-icon-bubble']) { var tmp = document.createElement('div'); tmp.innerHTML = s['cart-icon-bubble']; var inner = tmp.querySelector('#cart-icon-bubble') || tmp; wrap.innerHTML = inner.innerHTML; }
      });
    } catch (e) {}
  }

  /* ---------------- setup widget (shared markup) ---------------- */
  function bindSetup(root, opts) {
    opts = opts || {};
    var modeBtns = els('[data-cgc-mode]', root);
    var dateIn = el('[data-cgc-date]', root);
    var timeSel = el('[data-cgc-time]', root);
    var headIn = el('[data-cgc-head]', root);
    var zipIn = el('[data-cgc-zip]', root);
    var addrIn = el('[data-cgc-address]', root);
    var zipMsg = el('[data-cgc-zipmsg]', root);

    var today = new Date();
    if (dateIn) { dateIn.min = dstr(today); dateIn.max = dstr(new Date(today.getTime() + MAX_DAYS * 864e5)); }

    function buildTimes() {
      if (!timeSel) return;
      var prev = state.time;
      timeSel.innerHTML = '';
      if (!state.date) { timeSel.appendChild(new Option('Pick a date first', '')); timeSel.disabled = true; return; }
      timeSel.disabled = false;
      var slots = slotsFor(state.date);
      timeSel.appendChild(new Option(slots.length ? 'Choose a time' : 'No times left today. Pick tomorrow.', ''));
      slots.forEach(function (s) { timeSel.appendChild(new Option(s, s)); });
      if (prev && slots.indexOf(prev) > -1) timeSel.value = prev; else { state.time = ''; }
    }
    function paint() {
      root.setAttribute('data-mode', state.mode);
      modeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cgc-mode') === state.mode ? 'true' : 'false'); });
      if (dateIn && dateIn.value !== state.date) dateIn.value = state.date;
      buildTimes();
      if (headIn && headIn.value !== state.headcount) headIn.value = state.headcount;
      if (zipIn && zipIn.value !== state.zip) zipIn.value = state.zip;
      if (addrIn && addrIn.value !== state.address) addrIn.value = state.address;
      if (zipMsg) { var z = zipStatus(state.zip); zipMsg.className = 'cgc-setup__zipmsg ' + z.cls; zipMsg.textContent = state.mode === 'delivery' ? z.msg : ''; }
      if (opts.onChange) opts.onChange();
    }
    modeBtns.forEach(function (b) { b.addEventListener('click', function () { state.mode = b.getAttribute('data-cgc-mode'); persist(); paint(); }); });
    if (dateIn) dateIn.addEventListener('change', function () { state.date = dateIn.value; buildTimes(); persist(); paint(); });
    if (timeSel) timeSel.addEventListener('change', function () { state.time = timeSel.value; persist(); paint(); });
    if (headIn) headIn.addEventListener('input', function () { state.headcount = headIn.value.replace(/\D/g, '').slice(0, 4); persist(); if (opts.onChange) opts.onChange(); });
    if (zipIn) zipIn.addEventListener('input', function () { state.zip = zipIn.value.replace(/\D/g, '').slice(0, 5); zipIn.value = state.zip; persist(); if (zipMsg) { var z = zipStatus(state.zip); zipMsg.className = 'cgc-setup__zipmsg ' + z.cls; zipMsg.textContent = z.msg; } if (opts.onChange) opts.onChange(); });
    if (addrIn) addrIn.addEventListener('input', function () { state.address = addrIn.value.slice(0, 200); persist(); if (opts.onChange) opts.onChange(); });
    paint();
    return { paint: paint };
  }

  /* ---------------- product helpers ---------------- */
  function cleanVariantTitle(t) {
    return String(t || '')
      .replace(/^1\s+/, '')
      .replace(/uoto/gi, 'up to')
      .replace(/\s*-\s*Serves up to (\d+) People/i, ' · serves $1')
      .replace(/Serves up to (\d+) People/i, 'serves $1')
      .replace(/\s+/g, ' ').trim();
  }
  function variantForQty(p, qty) {
    if (p.ladder) { var idx = Math.min(Math.max(qty, 1), p.variants.length) - 1; return { id: p.variants[idx].id, quantity: 1, price: p.variants[idx].price }; }
    return null;
  }

  /* ---------------- quick-add modal ---------------- */
  var modal, toastEl;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'cgc cgc-modal';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = '<div class="cgc-modal__panel"><button type="button" class="cgc-modal__close" aria-label="Close">×</button><div class="cgc-modal__content"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('cgc-modal__close')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    toastEl = document.createElement('div'); toastEl.className = 'cgc cgc-toast'; document.body.appendChild(toastEl);
    return modal;
  }
  function closeModal() { if (modal) { modal.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function toast(msg) { if (!toastEl) ensureModal(); toastEl.textContent = msg; toastEl.classList.add('is-visible'); clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200); }

  function openQuickAdd(p, mount) {
    var inline = !!mount;
    var host = inline ? mount : (ensureModal(), el('.cgc-modal__content', modal));
    var minQ = Math.max(1, +p.min_qty || 1);
    var sizes = !p.ladder && p.variants.length > 1;
    var html = '';
    if (!inline) html += p.image ? '<img class="cgc-modal__img" src="' + esc(p.image) + '" alt="">' : '';
    html += '<div class="cgc-modal__body">';
    if (!inline) html += '<h3>' + esc(p.title) + '</h3><p class="cgc-modal__desc">' + esc(p.desc) + '</p>';
    html += '<div class="cgc-modal__price" data-cgc-price></div>';
    if (sizes) {
      html += '<div class="cgc-opt"><span class="cgc-opt__title">' + esc(p.option_name || 'Size') + '</span><div class="cgc-choice">';
      p.variants.forEach(function (v, i) { html += '<label><input type="radio" name="cgc-var" value="' + v.id + '" ' + (i === 0 ? 'checked' : '') + (v.available ? '' : ' disabled') + '><span>' + esc(cleanVariantTitle(v.title)) + '</span><span class="cgc-choice__price">' + money(v.price) + '</span></label>'; });
      html += '</div></div>';
    }
    (p.choices || []).forEach(function (c, ci) {
      html += '<div class="cgc-opt"><span class="cgc-opt__title">' + esc(c.name) + '</span><div class="cgc-choice">';
      c.values.forEach(function (v, i) { html += '<label><input type="radio" name="cgc-choice-' + ci + '" value="' + esc(v) + '" ' + (i === 0 ? 'checked' : '') + '><span>' + esc(v) + '</span></label>'; });
      html += '</div></div>';
    });
    html += '<div class="cgc-opt"><span class="cgc-opt__title">Quantity' + (p.unit ? ' <span style="text-transform:none;letter-spacing:0;font-weight:400">(' + esc(p.unit_plural || p.unit) + ')</span>' : '') + '</span>';
    html += '<div class="cgc-buy__row"><div class="cgc-qty"><button type="button" data-cgc-dec aria-label="Decrease">−</button><input type="number" inputmode="numeric" data-cgc-qty value="' + minQ + '" min="' + minQ + '" max="' + (p.ladder ? p.variants.length : 500) + '"><button type="button" data-cgc-inc aria-label="Increase">+</button></div>';
    if (minQ > 1) html += '<span class="cgc-modal__hint">Minimum ' + minQ + ' ' + esc(p.unit_plural || 'people') + '</span>';
    if (p.serves) html += '<span class="cgc-modal__hint" data-cgc-serves></span>';
    html += '</div></div>';
    html += '<div class="cgc-opt"><label for="cgc-notes">Special instructions <span style="text-transform:none;letter-spacing:0;font-weight:400">(optional)</span></label><textarea id="cgc-notes" data-cgc-notes placeholder="Allergies, no onions, labels for boxes, anything the kitchen should know"></textarea></div>';
    html += '<p class="cgc-modal__err" data-cgc-err></p>';
    html += '</div>';
    html += '<div class="cgc-modal__foot"><button type="button" class="cgc-add" data-cgc-submit>Add to order</button></div>';
    host.innerHTML = html;

    var qtyIn = el('[data-cgc-qty]', host), priceEl = el('[data-cgc-price]', host), servesEl = el('[data-cgc-serves]', host), err = el('[data-cgc-err]', host);
    function selVariant() {
      if (p.ladder) return null;
      var r = el('input[name="cgc-var"]:checked', host);
      var id = r ? +r.value : p.variants[0].id;
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i];
      return p.variants[0];
    }
    function qty() { var q = parseInt(qtyIn.value, 10); if (isNaN(q) || q < minQ) q = minQ; var mx = +qtyIn.max; if (q > mx) q = mx; qtyIn.value = q; return q; }
    function paintPrice() {
      var q = qty(), unitPrice = p.ladder ? p.variants[0].price : selVariant().price;
      var total = p.ladder ? (variantForQty(p, q).price) : unitPrice * q;
      priceEl.innerHTML = money(total) + ' <small>' + (q > 1 ? q + ' × ' + money(unitPrice) + (p.unit ? ' / ' + esc(p.unit) : '') : (p.unit ? 'per ' + esc(p.unit) : '')) + '</small>';
      if (servesEl && p.serves) servesEl.textContent = 'Feeds about ' + (p.serves * q) + ' people';
      el('[data-cgc-dec]', host).disabled = q <= minQ;
    }
    el('[data-cgc-dec]', host).addEventListener('click', function () { qtyIn.value = qty() - 1; paintPrice(); });
    el('[data-cgc-inc]', host).addEventListener('click', function () { qtyIn.value = qty() + 1; paintPrice(); });
    qtyIn.addEventListener('input', paintPrice);
    els('input[type=radio]', host).forEach(function (r) { r.addEventListener('change', paintPrice); });
    paintPrice();

    el('[data-cgc-submit]', host).addEventListener('click', function () {
      var btn = this; btn.disabled = true; btn.textContent = 'Adding…'; err.classList.remove('is-visible');
      var q = qty();
      var props = {};
      (p.choices || []).forEach(function (c, ci) { var r = el('input[name="cgc-choice-' + ci + '"]:checked', host); if (r) props[c.name] = r.value; });
      var notes = (el('[data-cgc-notes]', host).value || '').trim(); if (notes) props['Special instructions'] = notes.slice(0, 250);
      var line = p.ladder ? variantForQty(p, q) : { id: selVariant().id, quantity: q };
      addItem(line.id, line.quantity, props).then(function () {
        refreshThemeCartBubble();
        btn.disabled = false; btn.textContent = 'Add to order';
        if (inline) { toast('Added to your catering order'); } else { closeModal(); }
        openDrawer();
      }).catch(function (e) { btn.disabled = false; btn.textContent = 'Add to order'; err.textContent = e.message || 'Could not add this item. Try again.'; err.classList.add('is-visible'); });
    });

    if (!inline) { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; el('.cgc-modal__panel', modal).scrollTop = 0; }
  }

  /* ---------------- side cart drawer ---------------- */
  var drawer;
  function ensureDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'cgc cgc-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = '<div class="cgc-drawer__scrim" data-cgc-drawer-close></div>' +
      '<aside class="cgc-drawer__panel" role="dialog" aria-label="Your catering order">' +
        '<div class="cgc-drawer__head"><h3>Your catering order</h3><button type="button" class="cgc-drawer__close" data-cgc-drawer-close aria-label="Close">×</button></div>' +
        '<p class="cgc-drawer__when" data-cgc-drawer-when></p>' +
        '<div class="cgc-drawer__items" data-cgc-drawer-items></div>' +
        '<div class="cgc-drawer__foot">' +
          '<div class="cgc-bar__min" data-cgc-drawer-min><span data-cgc-drawer-mintext></span><div class="cgc-bar__track"><div class="cgc-bar__fill"></div></div></div>' +
          '<div class="cgc-drawer__total"><span>Subtotal</span><strong data-cgc-drawer-sub>$0.00</strong></div>' +
          '<p class="cgc-drawer__note">Taxes and the $25 delivery fee are added at checkout. You confirm date, time and address on the next step.</p>' +
          '<a class="cgc-bar__cta cgc-drawer__cta" href="/cart">Review &amp; check out</a>' +
          '<button type="button" class="cgc-drawer__more" data-cgc-drawer-close>Keep adding items</button>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cgc-drawer-close]')) { closeDrawer(); return; }
      var b = e.target.closest('[data-cgc-line]'); if (!b) return;
      var key = b.getAttribute('data-cgc-line'), act = b.getAttribute('data-cgc-act');
      var line = (cart.items || []).filter(function (i) { return i.key === key; })[0]; if (!line) return;
      var q = act === 'inc' ? line.quantity + 1 : act === 'dec' ? line.quantity - 1 : 0;
      b.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function (r) { return r.json(); }).then(function (c) { cart = c; emit(); refreshThemeCartBubble(); }).catch(function () { b.disabled = false; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    onCart(paintDrawer);
    return drawer;
  }
  function paintDrawer(c) {
    if (!drawer || !c) return;
    var items = c.items || [], sub = c.items_subtotal_price || 0;
    var host = el('[data-cgc-drawer-items]', drawer);
    if (!items.length) { host.innerHTML = '<p class="cgc-drawer__empty">Nothing in your order yet.</p>'; }
    else {
      host.innerHTML = items.map(function (it) {
        var props = Object.keys(it.properties || {}).filter(function (k) { return it.properties[k]; }).map(function (k) { return esc(k) + ': ' + esc(it.properties[k]); });
        var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cgc-drawer__meta">' + esc(cleanVariantTitle(it.variant_title)) + '</div>' : '';
        return '<div class="cgc-drawer__item">' +
          (it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')) + '" alt="">' : '<span class="cgc-drawer__noimg"></span>') +
          '<div class="cgc-drawer__body"><div class="cgc-drawer__title">' + esc(it.product_title) + '</div>' + vt +
          (props.length ? '<div class="cgc-drawer__meta">' + props.join(' · ') + '</div>' : '') +
          '<div class="cgc-drawer__row"><div class="cgc-qty cgc-qty--sm"><button type="button" data-cgc-line="' + esc(it.key) + '" data-cgc-act="dec" aria-label="Less">−</button><span>' + it.quantity + '</span><button type="button" data-cgc-line="' + esc(it.key) + '" data-cgc-act="inc" aria-label="More">+</button></div>' +
          '<strong>' + money(it.final_line_price) + '</strong><button type="button" class="cgc-drawer__remove" data-cgc-line="' + esc(it.key) + '" data-cgc-act="remove">Remove</button></div></div></div>';
      }).join('');
    }
    el('[data-cgc-drawer-sub]', drawer).textContent = money(sub);
    var when = state.date ? (niceDate(state.date) + (state.time ? ' · ' + state.time : '')) : 'date and time not set yet';
    el('[data-cgc-drawer-when]', drawer).textContent = (state.mode === 'delivery' ? 'Delivery' : 'Pickup') + ' · ' + when + (state.headcount ? ' · ' + state.headcount + ' people' : '');
    var minBox = el('[data-cgc-drawer-min]', drawer);
    if (state.mode === 'delivery') {
      minBox.style.display = '';
      el('.cgc-bar__fill', minBox).style.width = Math.min(100, Math.round(sub / DELIVERY_MIN * 100)) + '%';
      minBox.classList.toggle('is-met', sub >= DELIVERY_MIN);
      el('[data-cgc-drawer-mintext]', minBox).textContent = sub >= DELIVERY_MIN ? 'Delivery minimum met' : money(DELIVERY_MIN - sub) + ' to reach the $' + (DELIVERY_MIN / 100).toFixed(0) + ' delivery minimum';
    } else { minBox.style.display = 'none'; }
    el('.cgc-drawer__cta', drawer).style.display = items.length ? '' : 'none';
  }
  function openDrawer() { ensureDrawer(); paintDrawer(cart); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  /* ---------------- menu page ---------------- */
  function initMenu(root) {
    var setup = el('[data-cgc-setup]', root);
    if (setup) bindSetup(setup);
    var products = {};
    els('script[data-cgc-product]', root).forEach(function (s) { try { var p = JSON.parse(s.textContent); products[p.id] = p; } catch (e) {} });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cgc-add]'); if (!b) return;
      e.preventDefault();
      var p = products[b.getAttribute('data-cgc-add')]; if (!p) return;
      openQuickAdd(p);
    });
    // scroll-spy nav
    var links = els('.cgc-nav a', root), secs = els('.cgc-section', root);
    function spy() {
      var y = window.scrollY + 120, cur = secs[0];
      secs.forEach(function (s) { if (s.offsetTop <= y) cur = s; });
      links.forEach(function (a) { a.classList.toggle('is-active', cur && a.getAttribute('href') === '#' + cur.id); });
      var act = el('.cgc-nav a.is-active', root); if (act && act.scrollIntoView) { var nav = act.parentNode; var left = act.offsetLeft - nav.clientWidth / 2 + act.clientWidth / 2; nav.scrollTo({ left: left, behavior: 'smooth' }); }
    }
    window.addEventListener('scroll', spy, { passive: true }); spy();
    links.forEach(function (a) { a.addEventListener('click', function (e) { var t = el(a.getAttribute('href')); if (t) { e.preventDefault(); window.scrollTo({ top: t.offsetTop - 60, behavior: 'smooth' }); } }); });
    // sticky bar
    var bar = el('[data-cgc-bar]', root);
    if (bar) { var cta = el('.cgc-bar__cta', bar); if (cta) cta.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); }
    onCart(function (c) {
      var count = c.item_count || 0, sub = c.items_subtotal_price || 0;
      if (!bar) return;
      bar.classList.toggle('is-visible', count > 0);
      el('[data-cgc-bar-count]', bar).textContent = count + (count === 1 ? ' item' : ' items');
      el('[data-cgc-bar-sub]', bar).textContent = money(sub);
      var when = state.date ? (niceDate(state.date) + (state.time ? ' · ' + state.time : '')) : 'Date not set';
      el('[data-cgc-bar-when]', bar).textContent = (state.mode === 'delivery' ? 'Delivery' : 'Pickup') + ' · ' + when;
      var minBox = el('[data-cgc-bar-min]', bar);
      if (state.mode === 'delivery') {
        minBox.style.display = '';
        var pct = Math.min(100, Math.round(sub / DELIVERY_MIN * 100));
        el('.cgc-bar__fill', minBox).style.width = pct + '%';
        minBox.classList.toggle('is-met', sub >= DELIVERY_MIN);
        el('[data-cgc-bar-mintext]', minBox).textContent = sub >= DELIVERY_MIN ? 'Delivery minimum met' : money(DELIVERY_MIN - sub) + ' to reach the $' + (DELIVERY_MIN / 100).toFixed(0) + ' delivery minimum';
      } else { minBox.style.display = 'none'; }
      // mark cards in cart
      var inCart = {};
      (c.items || []).forEach(function (it) { inCart[it.product_id] = (inCart[it.product_id] || 0) + it.quantity; });
      els('.cgc-card', root).forEach(function (card) { var pid = card.getAttribute('data-product-id'); card.classList.toggle('is-in-cart', !!inCart[pid]); var tag = el('.cgc-card__incart', card); if (tag) tag.textContent = inCart[pid] ? 'In your order' : ''; });
    });
    loadCart().then(function () { if (setup) { /* repaint with cart-synced state */ bindSetupRepaint(setup); } });
  }
  function bindSetupRepaint(setup) { els('[data-cgc-mode]', setup).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cgc-mode') === state.mode ? 'true' : 'false'); }); setup.setAttribute('data-mode', state.mode); var d = el('[data-cgc-date]', setup); if (d) { d.value = state.date; d.dispatchEvent(new Event('change')); } var h = el('[data-cgc-head]', setup); if (h) h.value = state.headcount; var z = el('[data-cgc-zip]', setup); if (z) z.value = state.zip; }

  /* ---------------- cart panel ---------------- */
  function initCartPanel(root) {
    var setup = el('[data-cgc-setup]', root);
    var status = el('[data-cgc-status]', root);
    var checkout = document.getElementById('checkout');
    var subtotal = +root.getAttribute('data-subtotal') || 0;
    function paintStatus() {
      var errs = validate(subtotal);
      if (!status) return;
      if (errs.length) {
        status.className = 'cgc-cartpanel__status is-error';
        status.innerHTML = '<strong>Before checkout:</strong><ul>' + errs.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
      } else {
        status.className = 'cgc-cartpanel__status';
        status.innerHTML = '<strong>' + (state.mode === 'delivery' ? 'Delivery' : 'Pickup') + ' on ' + esc(niceDate(state.date)) + ' at ' + esc(state.time) + '</strong>' + (state.headcount ? ' for ' + esc(state.headcount) + ' people' : '') + (state.mode === 'delivery' ? '. $' + (DELIVERY_FEE / 100).toFixed(0) + ' delivery fee is added at checkout. Choose <em>Ship</em> at checkout and enter the event address.' : '. Choose <em>Pick up</em> at checkout. 6751 Painter Ave, Whittier.');
      }
      return errs;
    }
    loadCart().then(function () { hydrateFromCart(cart); if (setup) bindSetup(setup, { onChange: paintStatus }); paintStatus(); });
    if (checkout) {
      checkout.addEventListener('click', function (e) {
        var errs = validate(subtotal);
        if (errs.length) { e.preventDefault(); e.stopImmediatePropagation(); paintStatus(); root.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        else { persist(true); }
      }, true);
    }
  }

  /* ---------------- PDP buy box ---------------- */
  function initBuyBox(root) {
    var p; try { p = JSON.parse(el('script[data-cgc-product]', root).textContent); } catch (e) { return; }
    // Catering products: replace the restaurant "Order now" (Toast) box with the catering buy box
    var ot = document.getElementById('cg-ot');
    if (ot && ot.parentNode) { ot.parentNode.insertBefore(root, ot); ot.style.display = 'none'; }
    openQuickAdd(p, el('[data-cgc-buy-mount]', root));
    loadCart();
  }

  /* ---------------- boot ---------------- */
  function boot() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon && (el('[data-cgc-menu]') || el('[data-cgc-buybox]'))) cartIcon.addEventListener('click', function (e) { e.preventDefault(); if (!cart) loadCart().then(openDrawer); else openDrawer(); });
    els('[data-cgc-menu]').forEach(initMenu);
    els('[data-cgc-cartpanel]').forEach(initCartPanel);
    els('[data-cgc-buybox]').forEach(initBuyBox);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.CGCatering = { state: state, validate: validate, attributes: attributes, openQuickAdd: openQuickAdd, openDrawer: openDrawer, money: money };
})();
